export default __webpack_public_path__ + "static/4-c3c528fe525d537e38352bf062fd4a99.png";